export const GET_SKILLS = 'skills/GET_SKILLS'
export const GET_SKILLS_SUCCESSFUL = 'covers/GET_SKILLS_SUCCESSFUL'
export const GET_SKILLS_FAILURE = 'covers/GET_SKILLS_FAILURE'
